import { TOGGLE_FEATURE } from "../constants";
import get from "lodash/get";

function GET_FEATURE_FLAG_FROM_LS() {
  try {
    return localStorage.getItem("featureFlags")
      ? JSON.parse(localStorage.getItem("featureFlags"))
      : {};
  } catch (err) {
    return {};
  }
}

export function haveAccessToFeature(feature) {
  const featureFlags = GET_FEATURE_FLAG_FROM_LS();
  const hasAccess = featureFlags.hasOwnProperty(feature)
    ? featureFlags[feature]
    : false;

  if (hasAccess) {
    return true;
  }

  return false;
}

export function getFlagValue(feature) {
  const featureFlags = GET_FEATURE_FLAG_FROM_LS();
  return featureFlags[feature];
}

export function isGlobalFeatureEnabled(feat) {
  try {
    const features = localStorage.getItem(TOGGLE_FEATURE);
    const featuresJson = JSON.parse(features);
    return get(featuresJson, feat, false);
  } catch (e) {
    return false;
  }
}

export const getMexApiMigrations = (feature) => {
  try {
    let flags = JSON.parse(localStorage.getItem("mexApiMigrations"));
    return get(flags, feature) || false;
  } catch (e) {
    console.log(
      "error parsing the flag value from localstorage: mexApiMigrations",
      e
    );
    return false;
  }
};
